import React, { useCallback, useMemo, useState } from "react";

// when we have more panels, add them here
export type RailItem = "layers" | "token" | "info";

type RailContextType = {
  selected: RailItem;
  select: (toSelect: RailItem) => void;
};

const RailContextDefaults: RailContextType = {
  selected: "layers",
  select: () => null,
};

const RailContext = React.createContext<RailContextType>(RailContextDefaults);

const useRailState = (
  selectedItem: RailItem = RailContextDefaults.selected
): RailContextType => {
  const [selected, selectRail] = useState<RailItem>(selectedItem);

  const select = useCallback((item: RailItem) => {
    selectRail(item);
  }, []);

  /*
    this is a much more complicated process in wayfinder,
    with numerous URLs and an auth scheme. leaving this as
    its own provider for now, in case auth comes back.
    otherwise this should just live in UIContext
  */

  return useMemo(
    () => ({
      selected,
      select,
    }),
    [selected, select]
  );
};

export default RailContext;
export { useRailState };
